import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FileUploader } from 'ng2-file-upload';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { MatDialogRef, MatDialog } from '@angular/material';
import { UploadService } from 'src/app/services/upload.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { VariaveisArquivoResumoPedidoModalComponent } from '../variaveis-arquivo-resumo-pedido-modal/variaveis-arquivo-resumo-pedido-modal.component';
import { ArquivoResumoPedidoService } from 'src/app/services/arquivo-resumo-pedido.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-arquivo-resumo-pedido-modal',
  templateUrl: './arquivo-resumo-pedido-modal.component.html',
  styleUrls: ['./arquivo-resumo-pedido-modal.component.scss']
})
export class ArquivoResumoPedidoModalComponent implements OnInit {
  uploadForm: FormGroup;

  public config: PerfectScrollbarConfigInterface = {};

  uploader = new FileUploader({
    isHTML5: true
  });

  enviarArquivo: boolean;

  existeArquivo = false;

  monitorSelecionado = 0;
  monitorSelecionadoDescricao = 'Vendas';

  monitores = [
    { id: 0, nome: 'Vendas' },
    { id: 1, nome: 'Integração' },
    { id: 2, nome: 'Financiamento' },
    { id: 3, nome: 'Financeiro' },
    { id: 4, nome: 'Separação' },
    { id: 5, nome: 'Fiscal' },
    { id: 6, nome: 'Expedição' },
    { id: 10, nome: 'Pedidos' },
    { id: 12, nome: 'Conferência' },
    { id: 13, nome: 'Verificação' },
    { id: 14, nome: 'Análise Financeira' },
    { id: 15, nome: 'Faturamento' },
    { id: 16, nome: 'Triagem' },
    { id: 17, nome: 'Pendência' }
  ];

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private dialogRef: MatDialogRef<ArquivoResumoPedidoModalComponent>,
    private uploadService: UploadService,
    private fb: FormBuilder,
    private utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    private arquivoResumoPedidoService: ArquivoResumoPedidoService
  ) { }

  ngOnInit(): void {
    this.uploadForm = this.fb.group({
      document: [null, [Validators.required]]
    });

    this.buscarArquivoResumoPedido();
  }

  buscarArquivoResumoPedido() {
    this.carregandoService.mostra('buscarArquivoResumoPedido');

    this.arquivoResumoPedidoService.consultaExisteArquivoResumo(this.monitorSelecionado).subscribe(
      (existeArquivo) => {
        this.existeArquivo = existeArquivo;
        this.carregandoService.esconde('buscarArquivoResumoPedido');
      },
      (erro) => {
        this.carregandoService.esconde('buscarArquivoResumoPedido');
        this.notificacaoService.erro(erro);
      }
    );
  }

  selecionarMonitor() {
    this.monitorSelecionadoDescricao = this.monitores.find(p => p.id === this.monitorSelecionado).nome;
    this.buscarArquivoResumoPedido();
  }

  limparEnvio() {
    this.enviarArquivo = undefined;
    this.uploader.clearQueue();
    this.uploader.queue = [];
    this.uploadForm = this.fb.group({
      document: [null, [Validators.required]]
    });

    this.buscarArquivoResumoPedido();
  }

  baixarArquivo() {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoResumoPedidoService.baixarArquivoPorMonitor(this.monitorSelecionado).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, 'monitor_' + this.monitorSelecionadoDescricao + '.docx');
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  excluirArquivo() {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Arquivo de Impressão do Monitor ' + this.monitorSelecionadoDescricao,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirArquivo');
        this.arquivoResumoPedidoService.excluirArquivoPorMonitor(this.monitorSelecionado).subscribe(() => {
          this.notificacaoService.sucesso('Arquivo excluído com sucesso!!');

          this.limparEnvio();

          this.carregandoService.esconde('excluirArquivo');
        }, (erro) => {
          this.carregandoService.esconde('excluirArquivo');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  abrirModalVariaveis() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(VariaveisArquivoResumoPedidoModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        monitorSelecionado: this.monitorSelecionado,
        monitorSelecionadoDescricao: this.monitorSelecionadoDescricao
      },
      panelClass: 'modal-card'
    });
  }

  uploadSubmit() {
    for (let i = 0; i < this.uploader.queue.length; i++) {
      let fileItem = this.uploader.queue[i]._file;
      if (fileItem.size > 10000000) {
        alert('Cada arquivo deve possuir no máximo 10 MB.');
        return;
      }
    }

    let data = new FormData();

    for (let j = 0; j < this.uploader.queue.length; j++) {
      let fileItem = this.uploader.queue[j]._file;
      data.append('monitor', this.monitorSelecionado.toString());
      data.append('file', fileItem);
      data.append('fileSeq', 'seq' + j);
    }

    this.carregandoService.mostra('enviaArquivo');

    this.arquivoResumoPedidoService.enviarArquivoPorMonitor(data).subscribe((resp: any) => {
      this.notificacaoService.sucesso('Arquivo Enviado com Sucesso!!!');
      this.carregandoService.esconde('enviaArquivo');
      this.limparEnvio();
    }, (erro) => {
      this.carregandoService.esconde('enviaArquivo');
      this.notificacaoService.erro(erro);
    });

    this.uploader.clearQueue();

  }

  fechar() {
    this.dialogRef.close();
  }

}
